// src/hooks/useHardwareScan.js
//
// Пока компонент смонтирован (и active), его обработчик получает коды
// от беспроводного HID-сканера. handler получает СЫРОЙ код (строку) —
// ту же, что вернула бы камера.

import { useEffect, useRef } from 'react';
import { pushScanHandler } from '../utils/hardwareScanner';

export function useHardwareScan(handler, active = true) {
  const ref = useRef(handler);
  ref.current = handler;

  useEffect(() => {
    if (!active) return undefined;
    return pushScanHandler((code) => {
      if (ref.current) ref.current(code);
    });
  }, [active]);
}
